import { useMemo } from 'react'

import { StoryPanels } from '@/components/panels/StoryPanels.tsx'
import { useQueryStories } from '@/requests/queries/useQueryProject.ts'

type Props = {
  selectedLabel: string | null
  isShowDone: boolean
  isShowRelevant: boolean
  isShowUnscheduled: boolean
}

export const LabelStoriesView = ({ selectedLabel, isShowDone, isShowRelevant, isShowUnscheduled }: Props) => {
  const { stories: relevant } = useQueryStories('relevant')
  const { stories: unscheduled } = useQueryStories('unscheduled')
  const { stories: done } = useQueryStories('done')
  const filter = useMemo(() => filterLabelStories(selectedLabel), [selectedLabel])

  return (
    <StoryPanels
      done={filter(done)}
      relevant={filter(relevant)}
      unscheduled={filter(unscheduled)}
      isShowDone={isShowDone}
      isShowRelevant={isShowRelevant}
      isShowUnscheduled={isShowUnscheduled}
      isShowLoadPastIterationsButton
    />
  )
}

export const filterLabelStories = (selectedLabel: string | null) => (stories: Story[]) =>
  stories.filter((story) => story.labels.some((label) => label.name === selectedLabel))

type LabelSummaryProps = {
  selectedLabel: string
}

export const LabelSummary = ({ selectedLabel }: LabelSummaryProps) => {
  const { stories: relevant } = useQueryStories('relevant')
  const { stories: unscheduled } = useQueryStories('unscheduled')
  const { stories: done } = useQueryStories('done')

  if (!selectedLabel) return

  const { count, estimate } = filterLabelStories(selectedLabel)([...relevant, ...unscheduled, ...done]).reduce(
    (acc, curr) => {
      acc.estimate += curr.estimate === -1 ? 0 : curr.estimate
      acc.count += 1
      return acc
    },
    { count: 0, estimate: 0 },
  )

  return (
    <>
      <p className="font-EN-KR-body1-bold gap-2 pl-1">
        <span className="text-contents-secondary">Selected Label : </span>
        <span className="text-contents-primary">“{selectedLabel}”</span>
      </p>
      <img src="/images/dot-navy-icon.svg" alt="separator" />
      <p className="font-EN-KR-body1-regular text-contents-primary">
        {count} {count > 1 ? 'stories' : 'story'}, {estimate} point{estimate > 1 ? 's' : ''}
      </p>
    </>
  )
}
